import { styled } from '@mui/material/styles';

export const Root = styled('div')(({ theme }) => ({
	marginTop: '16px',
	backgroundColor: theme.palette.neutral[0],
	padding: 16,
	borderRadius: 8,
}));

export const PassengersTable = styled('div')(() => ({
	display: 'grid',
	gridGap: 8,
	gridTemplateColumns: '1fr',
	alignItems: 'center',
	// TODO: remove paddingRight when price is shown
	// paddingRight: 60,
	// TODO: return when price is shown
	// gridTemplateColumns: '/* 2fr 1fr */ 1fr max-content',
}));

export const LineWrapper = styled('div')(({ theme }) => ({
	marginTop: 8,
	marginBottom: 12,
	border: `1px solid ${theme.palette.neutral[40]}`,
}));
